export default (sname, name) => {
    const link = `//${window.location.host}/files/get_file.php?sname=${sname}&name=${name}`;

    window.open(link, '_blank');
};
